import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { buildBoxStats } from './widgetData';

const BoxViolinWidget = ({ widget, rows, variant = 'box' }) => {
  const { title, valueField, groupField } = widget.params || {};
  const stats = buildBoxStats({ rows, valueField, groupField });

  if (!stats.length) {
    return (
      <WidgetCard
        title={title || (variant === 'violin' ? 'Violin Plot' : 'Box Plot')}
        subtitle={valueField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Distribution data is not available yet." />
      </WidgetCard>
    );
  }

  const maxRange = Math.max(...stats.map((entry) => entry.max - entry.min || 1));

  return (
    <WidgetCard
      title={title || (variant === 'violin' ? 'Violin Plot' : 'Box Plot')}
      subtitle={valueField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {stats.map((entry) => {
          const range = entry.max - entry.min || 1;
          const widthPct = Math.max(15, (range / maxRange) * 100);
          return (
            <Box key={entry.label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="caption" sx={{ minWidth: 80 }}>
                {entry.label}
              </Typography>
              <Box sx={{ flex: 1 }}>
                <Box sx={{ position: 'relative', width: `${widthPct}%`, height: 18 }}>
                  {variant === 'violin' ? (
                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: 9,
                        background: 'linear-gradient(90deg, rgba(25,118,210,0.2), rgba(25,118,210,0.6))',
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 8,
                        height: 2,
                        backgroundColor: 'divider',
                      }}
                    />
                  )}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: `${((entry.q1 - entry.min) / range) * 100}%`,
                      width: `${((entry.q3 - entry.q1) / range) * 100}%`,
                      top: 4,
                      height: 10,
                      backgroundColor: 'primary.main',
                      borderRadius: 2,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      left: `${((entry.median - entry.min) / range) * 100}%`,
                      top: 2,
                      width: 2,
                      height: 14,
                      backgroundColor: 'primary.dark',
                    }}
                  />
                </Box>
              </Box>
              <Typography variant="caption" color="text.secondary">
                {entry.min.toFixed(1)}–{entry.max.toFixed(1)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </WidgetCard>
  );
};

export default BoxViolinWidget;
